import logo from './logo.svg';
import './App.css';
import DisplayStockRates from './DisplayStockRates';

function App() {
  return (
    <div>
      <DisplayStockRates />
    </div>
  );
}

export default App;
